/**
 * Returns the appropriate status options based on status type
 * @param {string} statusType - The type of status (inventory, product, consignment)
 * @returns {Array} Array of status options
 */
function getStatusOptions(statusType) {
  switch (statusType) {
    case 'inventory':
      return [
        { label: 'All', value: 'ALL' },
        { label: 'Available', value: 'AVAILABLE' },
        { label: 'In Transit', value: 'INTRANSIT' },
      ];
    case 'product':
      return [
        { label: 'All', value: 'ALL' },
        { label: 'Reserved', value: 'RESERVED' },
        { label: 'Unreserved', value: 'UNRESERVED' },
      ];
    case 'consignment':
      return [
        { label: 'All', value: 'ALL' },
        { label: 'Controlled', value: 'CONTROL' },
        { label: 'Uncontrolled', value: 'UNCONTROL' },
      ];
    default:
      return [];
  }
}

// Export the function as the default export
export default getStatusOptions;
